// extracted by mini-css-extract-plugin
export default {"root":"TruncatedCell_root__LbP51"};